import { bootstrapApplication } from '@angular/platform-browser';
import { KexpRootPage } from './app/pages/app/root-page/root.page';
import { kexpConfig } from './app/kexp.config';

bootstrapApplication(KexpRootPage, kexpConfig).catch((err) =>
  console.error(err)
);
